import Vue from 'vue'
import Vuex from 'vuex'

import Register from './modules/register'
import Env from './modules/Env'
import Settle from './modules/settle'

Vue.use(Vuex)

const store = new Vuex.Store({
	modules:{
		Register,
		Env,
    Settle
	}
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js